import { useTranslation } from "react-i18next";
import DefinitionListItem from "../../../ui/layout/DefinitionListItem";
import { PAGES_METADATA_KEY } from "./pageMap";

/**
 * The metadata the document was imported with, such as a title. Nothing when it has none.
 * The page map is left out: each segment shows its pages instead.
 */
export default function DocumentMetadata({ metadata }: { metadata: Readonly<Record<string, string>> }) {
  const { t } = useTranslation();
  const entries = Object.entries(metadata).filter(([name]) => name !== PAGES_METADATA_KEY);

  if (entries.length === 0) {
    return null;
  }
  return (
    <section>
      <div className="px-4 sm:px-0">
        <h3 className="app-title text-base font-semibold">{t("sources.document.metadata")}</h3>
      </div>
      <dl className="app-divider-top app-divide-y mt-6">
        {entries.map(([name, value]) => (
          <DefinitionListItem key={name} term={name} className="px-4 py-3 sm:px-0">
            {value}
          </DefinitionListItem>
        ))}
      </dl>
    </section>
  );
}
